import React, { useRef, useEffect } from 'react';
import { OptionTypeBase } from 'react-select';
import { Props as CreatableProps } from 'react-select/creatable';
import { useField } from '@unform/core';
import { IconBaseProps } from 'react-icons';

import { MdErrorOutline } from 'react-icons/md';
import { Container, ReactSelectElement, Error } from './styles';

interface Option {
  label: string;
  value: string;
}

interface Props extends CreatableProps<OptionTypeBase> {
  name: string;
  label: string;
  icon?: React.ComponentType<IconBaseProps>;
  options: Option[];
}

const CreatableSelect: React.FC<Props> = ({
  name,
  label,
  icon: Icon,
  options,
}) => {
  const selectRef = useRef(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      getValue: (ref: any) => {
        if (!ref.state.value) {
          return '';
        }
        return ref.state.value.value;
      },
      setValue: (ref: any, value: any) => {
        if (value) {
          const selectOptions: Option[] = ref.props.options;
          const selectedOption = selectOptions.find(
            option => option.value === value,
          );

          if (selectedOption) {
            ref.select.select.selectOption(selectedOption);
          }
        }
      },
    });
  }, [fieldName, registerField]);

  return (
    <Container hasError={!!error}>
      <label htmlFor={name}>
        {label}
        <div>
          {Icon && <Icon size={20} />}
          <ReactSelectElement
            ref={selectRef}
            defaultValue={defaultValue}
            placeholder="Selecione..."
            classNamePrefix="react-select"
            options={options}
            noOptionsMessage={() => 'Nenhuma opção encontrada'}
            formatCreateLabel={(inputValue: string) => `Criar "${inputValue}"`}
            isClearable
          />
        </div>
      </label>
      {error && (
        <Error>
          <MdErrorOutline size={16} />
          {error}
        </Error>
      )}
    </Container>
  );
};
export default CreatableSelect;
